import { FC } from 'react';

import Text from 'bloko/blocks/text';

import useTrls from 'hooks/translation/useTrls';

const CopySuccess: FC = () => {
    const trl = useTrls();

    return (
        <>
            <Text>{trl('campaign.copy.success.description')}</Text>
            <Text>{trl('campaign.copy.success.description.settings1')}</Text>
            <Text>{trl('campaign.copy.success.description.settings2')}</Text>
            <Text>{trl('campaign.copy.success.description.settings3')}</Text>
        </>
    );
};

export default CopySuccess;
